module.exports = __webpack_public_path__ + "static/media/gator-modal-slide-3.20dcf971.png";